module.exports = function csrf() {
    const crypto = require('crypto');
    return (req, res, next) => {
        if (!req.session) {
            console.warn('[!] CSRF middleware requires Session middleware to be registered before it.');
            return next();
        }

        if (req.method === 'GET' || req.method === 'HEAD' || req.method === 'OPTIONS') {
            if (!req.session._csrfToken) {
                req.session._csrfToken = crypto.randomBytes(16).toString('hex');
            }
            res.locals = res.locals || {};
            res.locals.csrfToken = req.session._csrfToken;
            req.csrfToken = () => req.session._csrfToken;
            return next();
        }

        const token = (req.body && req.body._csrf) || req.headers['x-csrf-token'] || req.headers['x-xsrf-token'];
        const tokenBuf = Buffer.from(token || '');
        const sessionBuf = Buffer.from(req.session._csrfToken || '');

        if (!token || tokenBuf.length !== sessionBuf.length || !crypto.timingSafeEqual(tokenBuf, sessionBuf)) {
            if (res.json) return res.json({ error: 'Invalid CSRF Token' }, 403);
            res.writeHead(403, { 'Content-Type': 'application/json' });
            return res.end(JSON.stringify({ error: 'Invalid CSRF Token' }));
        }

        next();
    };
};
